import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useState } from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { fetchGeonames } from './helpers';
import { geonamesApiKey, geonamesApiUrl } from './constants';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SuggestionItem = function SuggestionItem(_ref) {
  var name = _ref.name,
      description = _ref.description,
      info = _ref.info;

  if (info) {
    return /*#__PURE__*/_jsx("div", {
      className: "ptr-GeonamesSearchSuggestionItem is-disabled",
      children: /*#__PURE__*/_jsx("div", {
        className: "ptr-GeonamesSearchSuggestionItem-description",
        children: description
      })
    });
  } else {
    return /*#__PURE__*/_jsxs("div", {
      className: "ptr-GeonamesSearchSuggestionItem",
      children: [/*#__PURE__*/_jsx("div", {
        className: "ptr-GeonamesSearchSuggestionItem-name",
        children: name
      }), /*#__PURE__*/_jsx("div", {
        className: "ptr-GeonamesSearchSuggestionItem-description",
        children: description
      })]
    });
  }
};

SuggestionItem.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  info: PropTypes.string
};

var GeonamesSearch = function GeonamesSearch(_ref2) {
  var className = _ref2.className,
      onPlaceSelect = _ref2.onPlaceSelect,
      _ref2$apiKey = _ref2.apiKey,
      apiKey = _ref2$apiKey === void 0 ? geonamesApiKey : _ref2$apiKey,
      _ref2$apiUrl = _ref2.apiUrl,
      apiUrl = _ref2$apiUrl === void 0 ? geonamesApiUrl : _ref2$apiUrl,
      autoFocus = _ref2.autoFocus,
      _ref2$maxPlaces = _ref2.maxPlaces,
      maxPlaces = _ref2$maxPlaces === void 0 ? 5 : _ref2$maxPlaces,
      hideClearIcon = _ref2.hideClearIcon,
      hideSearchIcon = _ref2.hideSearchIcon,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? 'Search place...' : _ref2$placeholder;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      onItemsChange = _useState2[1];

  var handleOnSearch = function handleOnSearch(searchString) {
    fetchGeonames(apiUrl, apiKey, searchString, maxPlaces, onItemsChange);
  };

  var handleOnSelect = function handleOnSelect(item) {
    if (onPlaceSelect) {
      onPlaceSelect(item);
    }
  };

  var classes = classnames('ptr-GeonamesSearch', {}, className);
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    children: /*#__PURE__*/_jsx(ReactSearchAutocomplete, {
      autoFocus: autoFocus,
      items: items,
      inputDebounce: 50,
      onSearch: handleOnSearch,
      onSelect: handleOnSelect,
      placeholder: placeholder,
      formatResult: SuggestionItem,
      showClear: !hideClearIcon,
      showIcon: !hideSearchIcon
    })
  });
};

GeonamesSearch.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  apiKey: PropTypes.string,
  apiUrl: PropTypes.string,
  hideClearIcon: PropTypes.bool,
  hideSearchIcon: PropTypes.bool,
  maxPlaces: PropTypes.number,
  onPlaceSelect: PropTypes.func.isRequired,
  placeholder: PropTypes.string
};
export default GeonamesSearch;